import { Button } from 'components/buttons/Button/Button';
import NewDropdown from 'components/Dropdown/NewDropdown';
import HeaderButton from '../HeaderButton';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeCountry,
    changeLanguage,
    fetchLanguages,
    fetchCountries,
    selectLanguageState,
} from 'store/slices/languageSlice';
import { useEffect } from 'react';
import { fetchHomepage } from 'store/slices/HomepageSlice';
import React from 'react';

const CountrySelectorMenu = ({ onClose }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchLanguages());
        // @ts-ignore
        dispatch(fetchCountries());
    }, [dispatch]);

    const { country, language, languages, countries } = useSelector(selectLanguageState);

    const onChangeLanguage = language => setState({ ...state, language });
    const onChangeCountry = country => setState({ ...state, country });

    const [state, setState] = React.useState({
        language,
        country,
    });

    const handleOnSave = () => {
        dispatch(changeLanguage(state.language));
        dispatch(changeCountry(state.country));
        // @ts-ignore
        dispatch(fetchHomepage());
        onClose();
    };

    return (
        <div className="country-selector-popup">
            <div className="country-selector-popup__title">Change country</div>
            <HeaderButton onClick={onClose} size="small" />
            <NewDropdown
                label="PLEASE CHOOSE A COUNTRY"
                selectedValue={state.country}
                options={countries}
                onChange={onChangeCountry}
            />
            <NewDropdown
                label="AVAILABLE LANGUAGES"
                selectedValue={state.language}
                options={languages}
                onChange={onChangeLanguage}
            />
            <Button onClick={handleOnSave} type="default">
                SAVE YOUR CHOICE
            </Button>
        </div>
    );
};

export default CountrySelectorMenu;
